import React from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import { getPersonalizedMessages } from '../utility/personalizedMessages';
import { GN_CONTENT_TOUCHPOINT } from '../utility/constants';
import isNna from '../utility/nna';
import templateData from '../utility/getTemplateData';

export default function withConfirmationMessages(
  WrappedComponent,
  messages,
  renderedView
) {
  return class extends React.Component {
    static propTypes = {
      amount: PropTypes.number,
      confirmationNumber: PropTypes.string,
      giftaidFlag: PropTypes.bool,
      isVoucherFlow: PropTypes.bool,
      orgName: PropTypes.string,
      postBackData: PropTypes.object,
      rp_status: PropTypes.bool,
      signUpStatus: PropTypes.bool,
      receiptId: PropTypes.string,
      isExternalFlow: PropTypes.bool,
      isCampaigns: PropTypes.bool,
      personalizedMessages: PropTypes.object,
    };

    getGiftAidConfText = (label) => {
      if (this.props.giftaidFlag) {
        return this.props.rp_status ? label.giftAidRecurring : label.giftAid;
      }
      return '';
    };

    getYourDonationLabel = (personalizedMessages) => {
      if (this.props.isExternalFlow && personalizedMessages.success_header) {
        return personalizedMessages.success_header.replace(
          '<donationAmount>',
          this.props.amount
        );
      }

      let yourDonation = getContent('locals')('confirmation/confirmation')(
        'label.yourdonation',
        {
          amount: this.props.amount,
          orgName: this.props.isCampaigns
            ? templateData.campaignTitle
            : this.props.orgName,
        },
        {
          useHTML: true,
        }
      );
      if (this.props.isVoucherFlow) {
        yourDonation =
          getContent('locals')('confirmation/confirmation')(
            'label.voucher.yourdonation',
            { amount: this.props.amount, orgName: this.props.orgName },
            {
              useHTML: true,
            }
          ) || yourDonation;
      }

      return yourDonation;
    };

    getYourRPDonationLabel = () =>
      getContent('locals')('confirmation/confirmation')(
        this.props.isCampaigns
          ? 'label.campaignRPDonation'
          : 'label.yourRPdonation',
        { amount: this.props.amount, orgName: this.props.orgName },
        { useHTML: true }
      );

    getReturnTextLabel = (label) => {
      let returnText = label.returnText;
      returnText =
        returnText && returnText.replace('{orgName}', this.props.orgName);
      return returnText;
    };

    getReturnTextMemberLabel = (label) => {
      let returnTextMember = label.returnTextMember;
      returnTextMember =
        returnTextMember &&
        returnTextMember.replace('{orgName}', this.props.orgName);
      return returnTextMember;
    };

    getReturnToLabel = (label) => {
      let returnTo = label.returnto;
      returnTo = returnTo && returnTo.replace('{orgName}', this.props.orgName);
      return returnTo;
    };

    getTxnIdLabel = (label) => {
      let txnId = label.txnId;
      let id = this.props.rp_status
        ? this.props.confirmationNumber
        : this.props.receiptId;
      id = id || this.props.confirmationNumber;

      txnId = txnId && txnId.replace('{txnId}', id);
      return txnId;
    };

    getSignupProps = (label) => {
      return {
        signUpStatus: this.props.signUpStatus,
        successMessage:
          isNna(templateData.country) && renderedView !== 'pending'
            ? label.successMessageNna
            : label.successMessage,
        failMessage: label.failMessage,
      };
    };

    getPersonalizedContent = () => {
      if (this.props.isExternalFlow) {
        const psMessages = getPersonalizedMessages(GN_CONTENT_TOUCHPOINT, {
          isHtml: false,
        });

        if (psMessages.success_subheader) {
          psMessages.success_subheader = psMessages.success_subheader.replace(
            '<donationAmount>',
            this.props.amount
          );
        }
        return psMessages;
      }
      return {};
    };

    getOrgSuccess = () =>
      getContent('locals')('confirmation/confirmation')(
        'label.orgSuccess',
        { orgName: this.props.orgName },
        { useHTML: true }
      );

    render() {
      const { label = {} } = messages || {};
      const personalizedMessages = this.getPersonalizedContent();
      const returnText = this.getReturnTextLabel(label);
      const returnTextMember = this.getReturnTextMemberLabel(label);
      const returnTo = this.getReturnToLabel(label);
      const txnId = this.getTxnIdLabel(label);
      const yourRPdonation = this.getYourRPDonationLabel();
      const giftAidConfText = this.getGiftAidConfText(label);
      const yourDonation = this.getYourDonationLabel(personalizedMessages);
      const signUpProps = this.getSignupProps(label);
      const orgSuccess = this.getOrgSuccess();

      return (
        <WrappedComponent
          {...this.props}
          label={label}
          messages={messages}
          yourDonation={yourDonation}
          returnText={returnText}
          returnTextMember={returnTextMember}
          returnTo={returnTo}
          txnId={txnId}
          yourRPdonation={yourRPdonation}
          giftAidConfText={giftAidConfText}
          signUpProps={signUpProps}
          personalizedMessages={personalizedMessages}
          orgSuccess={orgSuccess}
        />
      );
    }
  };
}
